<template>
  <div v-if="lineItemData.length > 0" class="table-scope-88">
    <b-table :items="lineItemData" :fields="fields" :key="updateUI" show-empty>
      <template #cell(index)="data">
        <div>{{ data.index + 1 }}</div>
      </template>
      <template #cell(sku)="data">
        <div>{{ data.item.itemInstance.moreInformation.sku }}</div>
      </template>
      <template #cell(name)="data">
        <div>{{ data.item.itemInstance.moreInformation.name }}</div>
      </template>
      <template #cell(quantity)="data">
        <div class="price">{{ data.item.quantity }}</div>
      </template>
      <template #cell(unitPrice)="data">
        <div class="price">{{ formatMoneyNotUnit(divisionThousand(data.item.unitPrice)) }}</div>
      </template>
      <template #cell(totalAmount)="data">
        <div>{{ formatMoneyNotUnit(divisionThousand(data.item.totalAmount)) }}</div>
      </template>

      <template #row-details="data">
        <!--Chọn số EMEI/se-ri: useImeiAndSerial-->
        <div class="line dataUseImeiAndSerial" v-if="data.item.useImeiAndSerial">
          <div class="col-md-2 text-bold pull-left mt-2">IMEI/Serial:</div>
          <div class="col-md-10 pull-left selectDT">
             <el-select class="w-100" size="large" v-if="!loading" @change="changeSeries(data,$event)" @click.native="checkClickGetListSeri(data.item)" v-model="data.item.seriesNoTmp" multiple placeholder="Chọn seri">
              <el-option
                v-for="item in data.item.getSeri"
                :key="item.id"
                :label="item.text"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <!--Chọn số Lo/HSD: useProductBatch-->
        <div class="line dataUseProductBatch" v-if="data.item.useProductBatch">
          <div class="col-md-2 text-bold pull-left mt-2">Lô HSD:</div>
          <div class="col-md-10 pull-left selectLoHsd">
            <div class="line-lo-hsd">
              <span class="item-lo-hsd" v-for="(itemBatch, indexBatch) in data.item.batchTmp" :key="indexBatch">
                {{ itemBatch.batchCode }} - HSD: {{ convertDateItem(itemBatch.expirationDate) }} - SL:
                {{ itemBatch.quantityVal }}
                <i class="loHsd bx bx-x" @click="removeItemUseProductBatch(indexBatch, data.index)"></i>
              </span>
              <div class="lo-hsd-select" @click="loadDataUseProductBatch(data.index, data.item)"><i class="fa fa-chevron-down"></i></div>
            </div>
          </div>
        </div>
      </template>
    </b-table>

    <!-- dialog -->
    <el-dialog append-to-body title="Chọn lô HSD" width="700px" :visible.sync="openDataUseProductBatch" class="boxInfoProductBatch" v-if="openDataUseProductBatch">
      <div class="content-item-pos-change">
        <div>
          <input type="text" class="input w-100" placeholder="Tìm kiếm mã lô" v-model="keySearch" @keyup="changeKeySearch" />
        </div>
        <div class="mt-2 scrolTable">
          <table class="w-100">
            <thead>
              <tr>
                <th style="width:25%">Mã lô</th>
                <th style="width:15%">Hạn sử dụng</th>
                <th style="width:20%" class="text-center">Tồn kho</th>
                <th style="width:15%" class="text-center">Số lượng bán</th>
              </tr>
            </thead>
            <tbody v-if="dataBatchItemSearch.length > 0">
              <tr v-for="(item, index) in dataBatchItemSearch" :key="index">
                <td>
                  <input type="text" class="input w-90 disabled" placeholder="Tìm kiếm mã lô" disabled :value="item.batchCode" />
                </td>

                <td :class="item.isExpiration ? 'text-red' : 'text-black'">
                  {{ convertDateItem(item.expirationDate) }}
                  <div v-if="item.isExpiration" class="fz-12">
                    <i>Đã hết hạn</i>
                  </div>
                </td>

                <td class="text-center">{{ item.quantity }}</td>

                <td class="text-center" v-if="item.isExpiration && !checkExpirationDate">
                  <span class="num"><i class="el-icon-minus"></i></span>
                  <input type="text" class="input w-50 text-center disabled" value="0" min="0" disabled />
                  <span class="num"><i class="el-icon-plus"></i></span>
                </td>
                <td class="text-center" v-else>
                  <span class="num" @click="clickPlusBatch(item, 'minus')"><i class="el-icon-minus"></i></span>
                  <input v-if="item.quantity > 0" type="text" class="input w-50 text-center" v-model="item.quantityVal" min="0" @keydown.enter.prevent @keydown="allowNumbersOnly" @change="checkNumbersBatch(item)" @keyup="checkNumbersBatch(item)" />
                  <input type="text" class="input w-50 text-center disabled" value="0" min="0" disabled v-else />
                  <span class="num" @click="clickPlusBatch(item, 'plus')"><i class="el-icon-plus"></i></span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td class="text-black-500 text-center bd-td-head" colspan="4">Không có tìm thấy lô của sản phẩm</td>
              </tr>
            </tbody>
          </table>
          <div class="byExp" v-if="!checkExpirationDate && checkIndexExpiration">
            Để bán được sản phẩm đã hết hạn sử dụng, vui lòng đi tới <a target="_blank" href="/setting/config">Cấu hình bán hàng <i class="fa fa-chevron-right fz-12"></i></a>
          </div>
        </div>
        <div class="mt-3 w-100 text-right bdTopBottom">
          <button class="btn btn-default text-primary" @click="openDataUseProductBatch = false">Thoát</button>
          <button class="btn btn-primary" @click="saveDataUseProductBatch">Hoàn tất</button>
        </div>
      </div>
    </el-dialog>

    <!-- loading -->
    <div class="box-loading" v-if="loading">
      <div class="loading">
        <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "table-order-information",
  // props: ["lineItem"],
  props: {
    lineItem: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      lineItemData: JSON.parse(JSON.stringify(this.lineItem)),
      updateUI: 1,
      loading: false,

      fields: [
        {
          key: "index",
          label: "#",
          thStyle: { width: "1%", maxWidth: "20px" },
        },
        {
          key: "sku",
          label: "Mã SKU",
          thStyle: { width: "4%",  minWidth: "150px" },
        },
        {
          key: "name",
          label: "Tên phiên bản sản phẩm",
          thStyle: { width: "4%", minWidth: "250px" },
        },
        {
          key: "quantity",
          label: "Số lượng",
          thStyle: { width: "1%" },
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "unitPrice",
          label: "Đơn giá",
          thStyle: { width: "4%" },
          thClass: "text-right",
          tdClass: "text-right",
        },

        {
          key: "totalAmount",
          label: "Thành tiền",
          thStyle: { width: "4%" },
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],

      // seri

      // lo HSD
      openDataUseProductBatch: false,
      dataBatchItem: [],
      dataBatchItemChoose: [],
      keySearch: "",
      dataBatchItemSearch: [],
      lineItemSelect: [],
      indexLineItemSelect: "",
      checkExpirationDate: false,
      checkIndexExpiration: false,
    };
  },
  watch: {
    lineItemData: {
      handler() {
        console.log("update-data");
        this.$emit("update-data", this.lineItemData)
      },
      deep: true
    }
  },
  methods: {
    async clickGetListSeri(item) {
      try {
        this.loading = true;
        const sku = item.itemInstance.moreInformation.sku ? item.itemInstance.moreInformation.sku : "";
        item.getSeri = await this.getProductSeries(sku);
      } catch (error) {
        item.getSeri = []
        console.log(error)
      } finally {
        this.loading = false;
      }
    },
    checkClickGetListSeri(item) {
      if(item.getSeri.length == 0) this.clickGetListSeri(item)
    },
    changeSeries(data, value) {
      // console.log(value);
      const quantity = data.item.quantity
      if(value.length > quantity) {
        data.item.seriesNoTmp.splice(-1,1)
        this.alertMaxQuantity(quantity)
      }
    },
    alertMaxQuantity(max) {
      Swal.fire({
        icon: "warning",
        title: "Cảnh báo!",
        text: `Số lượng tối đa của sản phẩm là ${max}`, 
        confirmButtonText: "Xác nhận",
      });
    },

    //lo HSD
    async loadDataUseProductBatch(index, item) {
      this.dataBatchItemSearch = [];
      this.dataBatchItemChoose = [];
      this.openDataUseProductBatch = true;
      this.lineItemDataSelect = item;
      this.indexLineItemSelect = index;
      const sku = item.itemInstance.moreInformation.sku;
      this.checkExpirationDate = await this.getExpiredSale();

      this.dataBatchItem = await this.getProductBatch(sku); //Can thi bo dung them param this.checkExpirationDate

      const getIndexExpiration = this.dataBatchItem.length > 0 ? this.dataBatchItem.findIndex((item) => item.expirationDate == true) : -1;
      if (getIndexExpiration) {
        this.checkIndexExpiration = true;
      }

      this.changeKeySearch();
    },
    changeKeySearch() {
      const keySearch = this.keySearch.toLowerCase().trim();
      if (keySearch != "") {
        this.dataBatchItemSearch = [];
        return this.dataBatchItem.filter((item) => {
          const batchCode = item.batchCode.toLowerCase().trim();
          if (batchCode != "") {
            if (batchCode.includes(keySearch)) {
              this.dataBatchItemSearch.push(item);
            }
          }
        });
      } else {
        this.dataBatchItemSearch = this.dataBatchItem;
      }

      const indexLineItem = this.indexLineItemSelect;
      this.dataBatchItemSearch.map((item, index) => {
        if (this.lineItemData[indexLineItem].batchTmp.length > 0) {
          const indexVal = this.lineItemData[indexLineItem].batchTmp.findIndex((e) => e.batchCode == item.batchCode);
          if (indexVal != -1) {
            this.dataBatchItemSearch[index].quantityVal = this.lineItemData[indexLineItem].batchTmp[indexVal].quantityVal;
            this.dataBatchItemChoose.push(this.dataBatchItemSearch[index]);
          }
        }
      });
    },
    saveDataUseProductBatch() {
      if (this.dataBatchItemChoose.length > 0) {
        this.lineItemData[this.indexLineItemSelect].batchTmp = [];
        // let runTotal = 0;
        this.dataBatchItemChoose.map((item) => {
          if (item.quantityVal > 0) {
            this.lineItemData[this.indexLineItemSelect].batchTmp.push(item);
            // runTotal += item.quantityVal;
          }
        });
        // this.lineItemData[this.indexLineItemSelect].quantity = 0;
      }
      this.checkMaxQuantity(this.lineItemData[this.indexLineItemSelect])
      this.openDataUseProductBatch = false;
    },
    removeItemUseProductBatch(indexBatch, indexLineItem) {
      console.log({indexBatch, indexLineItem})
      this.lineItemData[indexLineItem].batchTmp.splice(indexBatch, 1);
      // let runTotal = 0;
      // if (this.lineItemData[indexLineItem].batchTmp.length > 0) {
      //   this.lineItemData[indexLineItem].batchTmp.map((item) => {
      //     if (item.quantityVal > 0) {
      //       runTotal += item.quantityVal;
      //     }
      //   });
      //   this.lineItemData[indexLineItem].quantity = runTotal;
      // } else {
      //   this.lineItemData[indexLineItem].quantity = 0;
      // }
    },
    checkMaxQuantity(item) {
      console.log("check max");
      const batchTmp = item.batchTmp
      let total = 0
      batchTmp.forEach(e => {
        total += e.quantityVal
      });
      if(total > item.quantity) {
        this.alertMaxQuantity(item.quantity)
      }
    },
    checkNumbersBatch(item) {
      if (isNaN(item.quantityVal) || item.quantityVal === undefined || item.quantityVal == "") {
        item.quantityVal = 0;
        return false;
      }
      item.quantityVal = item.quantityVal > item.quantity ? parseInt(item.quantity) : parseInt(item.quantityVal);
      if (this.dataBatchItemChoose.length > 0) {
        const indexVal = this.dataBatchItemChoose.findIndex((e) => e.batchCode == item.batchCode);
        if (indexVal != -1) {
          if (item.quantityVal > 0) {
            this.dataBatchItemChoose[indexVal].quantityVal = parseInt(item.quantityVal);
          } else {
            this.dataBatchItemChoose.splice(indexVal, 1);
          }
        } else {
          if (item.quantityVal > 0) {
            this.dataBatchItemChoose.push(item);
          }
        }
      } else {
        if (item.quantityVal > 0) {
          this.dataBatchItemChoose.push(item);
        }
      }
    },
    clickPlusBatch(item, type) {
      if (type == 'minus') {
        item.quantityVal--
        item.quantityVal = (item.quantityVal < 0) ? 0 : parseInt(item.quantityVal)
      }
      if (type == 'plus') {
        item.quantityVal++
        item.quantityVal = (item.quantityVal > item.quantity) ? parseInt(item.quantity) : (item.quantityVal)
      }
      this.checkNumbersBatch(item)
    },
  },
};
</script>

<style lang="scss" scoped>
.price {
  background-color: #ddd;
  padding: 16px 12px;
  border-radius: 4px;
}
.pointed-none {
  pointer-events: none;
}
</style>

<style lang="scss">
.table-scope-88 {
  .el-tag.el-tag--info {
    background-color: #f2f3f4;
    border: none;
    color: #3C3E49;
    padding: 14px;
  }
  .el-tag.el-tag--info .el-tag__close {
    color: #808890;
    background: transparent;
    font-size: 17px;
    font-weight: 600;
  }
  .el-tag.el-tag--info .el-tag__close:hover {
    background: transparent;
    color: red;
  }
  .el-select .el-input .el-select__caret {
    color: #23313e;
    font-size: 15px;
    font-weight: bold;
    padding-left: 1px;
  }
  
}
</style>
